import { API_HOST, API_KEY } from './const';

const MSG_DEFAULT = 'error de conexion a servidor';

/** Incluye timeout 408 + "No se puede conectar al servidor" en hasta 50 chars. */
function mensajeDesdeError(err) {
  if (err == null) return MSG_DEFAULT;
  if (typeof err === 'string') return err.slice(0, 50);
  const msg = typeof err.message === 'string' ? err.message : '';
  const errStr =
    typeof err.error === 'string'
      ? err.error
      : err.error?.message && typeof err.error.message === 'string'
        ? err.error.message
        : '';
  if (msg && errStr) {
    const combined = `${msg} · ${errStr}`;
    return combined.slice(0, 50);
  }
  const m =
    msg ||
    errStr ||
    (typeof err.error === 'string' ? err.error : err.error?.message) ||
    err.response?.data?.message;
  if (m && typeof m === 'string') return m.slice(0, 50);
  return MSG_DEFAULT;
}

/**
 * Registra en servidor (oficina_logs_conex) un fallo de red/timeout al llamar APIs externas.
 * No bloquea ni relanza: fallos del log se ignoran.
 */
export function registrarFalloConexion({
  baseUrl,
  url,
  providerLabel,
  error,
  token,
}) {
  if (typeof window === 'undefined') return;
  const path = String(url || '').replace(/^\//, '');
  const base = String(baseUrl || '').replace(/\/$/, '');
  const origen = `${providerLabel}|${base}/${path}`;

  const idRaw = localStorage.getItem('idUsu');
  let idPac = 0;
  if (idRaw && idRaw !== '0') {
    const n = parseInt(idRaw, 10);
    idPac = Number.isNaN(n) ? 0 : n;
  }

  const message = mensajeDesdeError(error);

  const headers = {
    'Content-Type': 'application/json',
    apiKey: API_KEY,
    apikey: API_KEY,
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  fetch(`${API_HOST}/logs/conexion`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ origen, message, idPac }),
    keepalive: true,
  }).catch((e) => {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[logConexionFallo] no se pudo registrar:', e?.message || e);
    }
  });
}
